import { render } from "./BovineTag.vue?vue&type=template&id=6d096896&scoped=true"
import script from "./BovineTag.vue?vue&type=script&lang=js"
export * from "./BovineTag.vue?vue&type=script&lang=js"

import "./BovineTag.vue?vue&type=style&index=0&id=6d096896&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d096896"]])

export default __exports__